import { render, staticRenderFns } from "./TrxDeposit.vue?vue&type=template&id=17a2306e"
import script from "./TrxDeposit.vue?vue&type=script&lang=js"
export * from "./TrxDeposit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports